<template>
  <div class="page">
    <HeaderTop :is_login="false"></HeaderTop>
    <div class="pageContent d-flex d-flex-middle d-flex-center">
      <div class="bmContent">
        <div class="progressBox">
          <BmProgress :steps="steps" :current-step="1" />
        </div>
        <div class="contentBox">
          <!-- <SelectGroup 
            v-if="currentView === 'selectGroup'" 
            :selectedType="groupType"
            @prev-step="handlePrev" 
            @next-step="handleGroupTypeSelected" 
          /> -->
          <HelpInfo 
            v-if="currentView === 'helpInfo'" 
            :groupType="groupType" 
            :helpId="helpId"
            :showPrev="showPrevButton"
            @changeHelpInfo="changeHelpInfo"
            @prev-step="handlePrev" 
            @next-step="handleNext" 
          />
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import HeaderTop from "@/components/HeaderTop.vue";
import Footer from "@/components/Footer.vue";
import BmProgress from "@/components/bm/bmProgress.vue";
import HelpInfo from "@/components/bm/helpInfo.vue";

export default {
  name: 'Step1SelectLocation',
  components: {
    HeaderTop,
    Footer,
    BmProgress,
    HelpInfo
  },
  data() {
    return {
      MOCK_PREFIX: process.env.VUE_APP_MOCK_PREFIX || '',
      steps: [
        { title: '阅读报名须知' },
        { title: '选择就读地点' },
        { title: '选择报名专业' },
        { title: '注册资料' },
        { title: '提交报名' },
        { title: '缴费' }
      ],
      groupType: '',
      currentView: 'helpInfo', // 'selectGroup' | 'helpInfo'
      helpId: null
    }
  },
  computed: {
    showPrevButton() {
      return sessionStorage.getItem('BM_NOTICE_OPTIONAL_SKIPPED') !== '1'
    }
  },
  created() {
    if(localStorage.getItem('userInfo')){
      this.loadStudentInfo()
    }else{
      const helpInfoStr = localStorage.getItem('helpInfo')
      if (helpInfoStr) {
        const helpInfo = JSON.parse(helpInfoStr)
        if (helpInfo && helpInfo.id) {
          this.helpId = helpInfo.id
        }
      }
    }
  },
  methods: {
    loadStudentInfo() {
      this.$http.get(this.MOCK_PREFIX + '/student/pc/register/queryStudentInfo?target_id=22b542ab707097').then(res => {
        if (res) {
          let helpId = res.helpId || ''
          if (!helpId) {
            const helpInfoStr = localStorage.getItem('helpInfo')
            if (helpInfoStr) {
              const helpInfo = JSON.parse(helpInfoStr)
              if (helpInfo && helpInfo.id) {
                helpId = helpInfo.id
              }
            }
          }
          
          this.helpId = helpId
        }
      })
    },
    handlePrev() {
      this.$router.push({ name: 'BmStepNotice' })
    },
    handleBackToGroupSelect() {
      this.currentView = 'helpInfo'
    },
    handleNext(data) {
      this.$router.push({ name: 'BmStepSelectMajor' })
    },
    changeHelpInfo(helpId){
      this.helpId = helpId
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  min-height: 100vh;
  position: relative;
}

.pageContent {
  padding: 20px;
  min-height: calc(100vh - 200px);
  margin-top: 70px;
  background: url('../../assets/bm/bmBg.png') no-repeat center center;
  background-size: 100% 100%;
}

.bmContent {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  border-radius: 8px;
  padding: 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.progressBox {
  width: 100%;
  margin-bottom: 20px;
}

.contentBox {
  width: 1000px;
  margin: 0 auto;
  border-top: 1px solid #E9EFF9;
}
</style>
